import { TableHeader } from '@recargas-dominicanas/core/components';
import { Table } from '@recargas-dominicanas/core/components';
import { useBusinessStore } from '../../../stores/businessStore';
import { UserItem } from './user-item/user-item.component';
import { style } from './users.module.css';

export function Users() {

  const { business, users } = useBusinessStore();

  return (
    <div className={style.container}>
      <Table style={style.table}>
        <TableHeader style={style.tableHeader}>
          <span>Nombre</span>
          <span>Usuario</span>
          <span>Contraseña</span>
        </TableHeader>
        <tbody>
          {
            users?.map(user => (
              <UserItem
                key={user.id}
                businessId={business!.id}
                businessUser={user}/>
            ))
          }
        </tbody>
      </Table>
    </div>
  );
}
